const courses = [
  {
    id: 1,
    image: "banner-management.jpg",
    bannerImg: "course-banner2.jpg",
    name: "Management",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    lesson: "5",
    enrolled: "56",
    price: "2 500 €",
    duration: "30H",
    type: "Management",
    language: null,
    review: null,
    title: "Intégrer le management d’équipe dans son activité professionnelle",
    about: `
<div class="tab-pane">
  <h3>ORGANISATION DE LA FORMATION</h3>
  <h4>Modalités pédagogiques et techniques :</h4>
  <ul>
    <li>Introduction des apprenants via Google Meet</li>
    <li>Partage et projection des documents durant la réunion</li>
    <li>Analyse de cas pratiques</li>
    <li>Exercices et quizz</li>
  </ul>
  
  <h4>Suivi de la mise en œuvre et méthode d’évaluation pour mesurer l’atteinte des objectifs :</h4>
  <ul>
    <li>Fiche de suivi</li>
    <li>Auto-évaluation</li>
    <li>Émargement en ligne sur Edusign</li>
    <li>Formulaire d’évaluation de formation</li>
  </ul>
  
  <h4>Concrétisation à la fin de la formation :</h4>
  <ul>
    <li>Un certificat attestant de la réalisation de la formation est fourni à la fin de l’action de formation.</li>
    <li>Toutes les informations liées au passage de la certification vous seront envoyées.</li>
    <li>Le passage de l’examen est compris dans le coût de la formation, et il est obligatoire de le passer à la fin de formation (cf. Article 8 de MonCompteFormation).</li>
  </ul>
  
  <h4>Contact :</h4>
  <p>Marion Frade - marion.frade01@gmail.com</p>
  
  <h4>Modalités d’accès tarifaire :</h4>
  <p>2500 € possible via un financement CPF (Mon compte formation), par l’OPCO ou abondement employeur, ou financement propre. CO2 FORMATION</p>
  
  <h4>Modalités d’évaluation :</h4>
  <p>
    Avant le début de la formation, un questionnaire de pré-formation sera remis aux participants. Le formateur utilisera les résultats pour évaluer les connaissances et compétences de chacun et ajustera ses méthodes pédagogiques en conséquence.
    À la fin de la formation, une évaluation sommative sera réalisée pour vérifier l'atteinte des objectifs. De plus, une évaluation de satisfaction immédiate (à chaud) sera effectuée, suivie d'une évaluation différée (à froid) deux mois plus tard pour recueillir des retours sur la formation et l'application des acquis en milieu professionnel.
  </p>
  
  <h4>Modalités de certification :</h4>
  <p>
    Une évaluation certificative sera réalisée pour valider la certification. Cette évaluation s'effectue à travers une préparation écrite et de 2 mises en situation professionnelle. Cette évaluation se déroule en visioconférence en direct, en une seule séance, avec 2 professionnels :
  </p>
  <ul>
    <li>Un représentant de l’organisme certificateur MANITUDE</li>
    <li>Un professionnel extérieur à MANITUDE dont la qualité est en lien avec la certification visée, en tant que Président du jury</li>
  </ul>
  <p>Soit 50% de personnes extérieures à l’organisme certificateur.</p>
  <p>
    La formation prépare à la certification détenue par Manitude, enregistrée le 09/02/2024 sous le numéro RS6516 au Répertoire Spécifique de France Compétences. La date d’échéance de la certification est le 09/02/2025.
  </p>
  
  <h4>Accessibilité des personnes en situation de handicap :</h4>
  <p>
    N'hésitez pas à nous signaler tout besoin d'accessibilité particulier d'un participant.
    Nous sommes prêts à personnaliser la formation ou à fournir des alternatives en fonction des besoins spécifiques. Nous proposons des rendez-vous à distance, et en cas de besoins particuliers liés à un handicap, la formation peut être adaptée en conséquence. CO2 FORMATION
  </p>
  
  <h4>Points forts et avantages de la formation :</h4>
  <ul>
    <li>Optimisez votre leadership : Développez des compétences de leadership pour inspirer et motiver vos équipes.</li>
    <li>Améliorez la communication interne : Apprenez à communiquer efficacement avec votre équipe pour favoriser la collaboration et la productivité.</li>
    <li>Prenez des décisions stratégiques : Maîtrisez l'art de la prise de décision pour guider votre équipe vers le succès.</li>
    <li>Gérez les conflits avec aisance : Acquérez des techniques pour résoudre les conflits et maintenir un environnement de travail harmonieux.</li>
  </ul>
  
  <p>
    Notre équipe pédagogique inclut un formateur de management qualifié - Mme Marion Frade - apportant une vaste expérience et une approche attentive à l'apprentissage. Elle vous accompagnera avec enthousiasme dans votre projet de formation et le développement de votre carrière professionnelle.
  </p>
</div>
`, module: `
<div class="tab-pane">
  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 1 : Définition d'Objectifs et Gestion de la Performance en Accord avec la Stratégie d'Entreprise (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Alignement des objectifs individuels et collectifs avec la stratégie d'entreprise.</li>
      <li>Méthodes et outils de suivi de la performance et d'évaluation des résultats.</li>
      <li>Techniques de communication et de motivation pour l'atteinte des objectifs.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 2 : Gestion de l'organisation et de la délégation des tâches en milieu professionnel inclusif (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation des compétences et des besoins individuels pour une délégation efficace et équitable.</li>
      <li>Promotion de la diversité et de l'inclusion au sein de l'équipe dans la répartition des responsabilités.</li>
      <li>Formation sur l'adaptation des processus de travail pour accueillir et soutenir les collaborateurs en situation de handicap.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 3 : Conduite des entretiens de suivi de performance et feedback constructif (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation des compétences et des profils pour une délégation efficace.</li>
      <li>Stratégies d'inclusion et d'adaptation pour les collaborateurs en situation de handicap.</li>
      <li>Techniques de planification et de répartition des tâches en équipe.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 4 : Planification et animation de réunions d'équipe pour favoriser la cohésion et l'engagement (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Techniques de préparation et de structuration des réunions efficaces.</li>
      <li>Méthodes d'animation participative pour encourager l'implication active des collaborateurs.</li>
      <li>Stratégies de suivi post-réunion pour renforcer la cohésion et l'engagement de l'équipe.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 5 : Communication efficace des décisions de l'entreprise pour maintenir la motivation et l'engagement (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Étapes clés pour annoncer des décisions d'entreprise de manière transparente et constructive.</li>
      <li>Techniques de communication empathique pour gérer les réactions des collaborateurs.</li>
      <li>Stratégies de maintien de la motivation et de l'engagement après l'annonce de décisions difficiles.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 6 : Gestion des situations managériales difficiles et communication adaptée pour assurer la cohésion d'équipe (3.5h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Identification et résolution de conflits interpersonnels au sein de l'équipe.</li>
      <li>Communication de mauvaises nouvelles et gestion des réactions émotionnelles.</li>
      <li>Stratégies pour maintenir la cohésion et la confiance de l'équipe en période de crise ou de changement.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>JOUR 7 : Communication stratégique pour managers : Mobiliser les équipes autour d'une vision de performance (4h)</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Développement d'une vision stratégique claire et inspirante pour l'équipe.</li>
      <li>Techniques de communication persuasive pour susciter l'adhésion et l'engagement des collaborateurs.</li>
      <li>Utilisation des canaux de communication appropriés pour diffuser la vision et les objectifs de performance de manière efficace et motivante.</li>
    </ul>
  </div>
</div>
`},
  {
    id: 2,
    image: "wordpress.webp",
    bannerImg: "course-banner1.jpg",
    name: "Digitale",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    language: "Langue française",
    enrolled: "77",
    price: "3 600 €",
    duration: "45H",
    type: "Digitale",
    title: "Formation WordPress",
    about: `
<div class="tab-pane">
  <h3>Cette formation est pour qui ?</h3>
  <ul>
    <li>Professionnels du web, développeurs, créateurs de contenu, marketeurs et toute personne souhaitant acquérir une compétence certifiée dans l’édition et la gestion de site web.</li>
    <li>Entrepreneurs et responsables de communication digitale.</li>
  </ul><br/>
  
  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Maîtriser les concepts essentiels de publication Web et la capacité de créer, télécharger, maintenir un site Web statique.</li>
  </ul><br/>
  
  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>
  
  <h3>Objectif final :</h3>
  <ul>
    <li>Appréhender le fonctionnement d'Internet et de la publication sur Internet pour optimiser la mise en ligne d'un contenu.</li>
    <li>Connaître les principes de base du HTML et utiliser les balises HTML courantes pour modifier la mise en page d'une page Web.</li>
    <li>Utiliser une application de création Web pour concevoir et mettre en forme des pages Web, formater du texte et travailler avec des hyperliens et des tableaux.</li>
    <li>Reconnaître et utiliser les formats d'image Web courants et créer des formulaires dans une page Web.</li>
    <li>Ajouter et utiliser des feuilles de style aux pages d'un site Web à l'aide des feuilles de style en cascade (CSS).</li>
    <li>Préparer des pages web en vue de leur publication à partir d'un serveur web.</li>
  </ul>
</div>
`,
    module: `<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p>
  
  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Introduction à WordPress et à la publication Web</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Fonctionnement d’Internet et hébergement Web.</li>
      <li>Présentation de WordPress et de son rôle dans la création de sites Web.</li>
      <li>Installation de WordPress sur un serveur local ou en ligne.</li>
      <li>Présentation du tableau de bord WordPress.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Bases du HTML et mise en page des pages Web</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Introduction au langage HTML et structure d'une page Web.</li>
      <li>Utilisation des balises HTML essentielles pour la mise en forme (h1, p, a, img, ul, ol).</li>
      <li>Création de liens hypertextes et intégration d’images dans une page Web.</li>
      <li>Application de styles CSS simples pour modifier l’apparence des éléments.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Création et gestion d’un site WordPress</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Choisir un thème WordPress et le personnaliser.</li>
      <li>Création et gestion des pages et articles.</li>
      <li>Gestion des menus et de la navigation.</li>
      <li>Intégration et mise en forme du texte, des hyperliens et des tableaux.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Gestion des médias et des formulaires</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Formats d’images adaptés au Web (JPEG, PNG, GIF, SVG).</li>
      <li>Insertion et optimisation des images pour un affichage fluide.</li>
      <li>Création de formulaires avec des extensions dédiées (Contact Form 7, WPForms).</li>
      <li>Gestion des vidéos et des fichiers audio dans WordPress.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Personnalisation avancée avec CSS et plugins</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Introduction aux feuilles de style CSS et leur intégration dans WordPress.</li>
      <li>Modification du design d’un site à l’aide du CSS.</li>
      <li>Utilisation des plugins pour ajouter des fonctionnalités (SEO, sécurité, sauvegarde).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Préparation et mise en ligne d’un site WordPress</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Organisation des fichiers et bonnes pratiques pour un site efficace.</li>
      <li>Vérification et validation du site avant publication.</li>
      <li>Utilisation d’un client FTP pour transférer le site sur un serveur.</li>
      <li>Sécurisation et maintenance d’un site WordPress.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du test ICDL et des compétences évaluées.</li>
      <li>Exercices pratiques pour valider les acquis.</li>
      <li>Passage d’un test blanc pour se préparer à l’examen.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale composée d’un test théorique en ligne et d’un projet pratique intégrateur.</li>
      <li>Attribution d’une certification attestant de la maîtrise des techniques d’édition de site web.</li>
    </ul>
  </div>
</div>`,
  },
  {
    id: 3,
    image: "logo-Powerpoint.jpg",
    bannerImg: "course-banner3.jpg",
    name: "Bureautique",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    price: "1 600 €",
    duration: "20H",
    type: "Digitale",
    language: "Langue française",
    title: "Formation PowerPoint",
    about: `
    <div class="tab-pane">
  <h3>Cette formation est pour qui ?</h3>
  <ul>
    <li>Professionnels souhaitant perfectionner leurs compétences en création de présentations.</li>
    <li>Cadres, commerciaux et responsables souhaitant optimiser leurs supports visuels dans le cadre de PréAO.</li>
    <li>Toute personne désireuse d’acquérir une compétence certifiée en outils de présentation.</li>
  </ul><br/>
  
  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Maîtriser les fonctionnalités principales des logiciels de création et de mise en forme d’une présentation de diapositives.</li>
  </ul><br/>
  
  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>
  
  <h3>Objectif final :</h3>
  <ul>
    <li>Reconnaître l'interface d'un logiciel de Présentation et ses principales fonctionnalités pour en assurer son utilisation.</li>
    <li>Créer et mettre en forme une diapositive en vue de faire une présentation.</li>
    <li>Éditer du texte et/ou un tableau, le mettre en forme, connaître les bonnes pratiques en la matière.</li>
    <li>Utiliser des diagrammes et des organigrammes pour illustrer une présentation.</li>
    <li>Créer et manipuler des objets : tables, graphiques, images, dessins (édition, ajustement, copie, déplacement) en utilisant les fonctions (simples) d'animation, de transition, de masquage et d'activation du diaporama pour enrichir une présentation.</li>
    <li>Créer un diaporama en utilisant les fonctions (simples) d'animation, de transition, de masquage et d'activation du diaporama et finaliser la présentation avant impression ou diffusion.</li>
  </ul>
</div>
`,
    module: `
<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p><br/>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Découverte de l’interface PowerPoint</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du ruban, des onglets et des outils essentiels.</li>
      <li>Navigation entre diapositives et affichages (normal, trieuse, mode diaporama).</li>
      <li>Gestion des fichiers : création, ouverture, enregistrement, exportation.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Création et mise en forme des diapositives</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Choix d’un modèle ou d’un thème.</li>
      <li>Ajout et suppression de diapositives.</li>
      <li>Paramétrage de la mise en page (orientation, dimensions).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Édition et mise en forme du texte et des tableaux</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Insertion et modification de texte.</li>
      <li>Gestion des polices, alignements, interlignes et styles.</li>
      <li>Création et mise en forme de tableaux (ajout de colonnes, lignes, styles).</li>
      <li>Bonnes pratiques pour rendre le contenu clair et lisible.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Utilisation des diagrammes et organigrammes</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Insérer et personnaliser un diagramme SmartArt.</li>
      <li>Créer un organigramme et ajuster sa structure.</li>
      <li>Modifier les couleurs et styles pour améliorer la lisibilité.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Création et manipulation d’objets</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Insérer et ajuster des images, dessins et icônes.</li>
      <li>Création et personnalisation de graphiques (barres, secteurs, histogrammes).</li>
      <li>Copie, déplacement et ajustement des objets sur une diapositive.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Animation et transition des diapositives</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Application des transitions entre diapositives.</li>
      <li>Ajout d’animations aux objets et au texte.</li>
      <li>Gestion des effets de masquage et d’apparition.</li>
      <li>Paramétrage des durées et enchaînements d’animations.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 7 : Finalisation et diffusion du diaporama</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Organisation et structuration des diapositives pour une présentation fluide.</li>
      <li>Utilisation du mode présentateur et des notes de présentation.</li>
      <li>Vérification orthographique et mise en page finale.</li>
      <li>Paramétrage de l’impression et exportation en PDF ou vidéo.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du test ICDL et des compétences évaluées.</li>
      <li>Exercices pratiques pour valider les acquis.</li>
      <li>Passage d’un test blanc pour se préparer à l’examen.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale composée d’un test théorique en ligne et d’un projet pratique intégrateur.</li>
      <li>Attribution d’une certification attestant de la maîtrise des outils de présentation pour un PréAO.</li>
    </ul>
  </div>
</div>
`,
  },
  {
    id: 4,
    image: "banner-photoshop.webp",
    bannerImg: "course-banner3.jpg",
    name: "Bureautique",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    price: "2 400 €",
    duration: "30H",
    language: "Langue française",
    type: "Digitale",
    title: "Formation Photoshop",
    about: `
<div class="tab-pane">
  <h3>Cette formation est pour qui ?</h3>
  <ul>
    <li>Professionnels de la communication, du marketing et de la création numérique.</li>
    <li>Graphistes, photographes et toute personne souhaitant développer ses compétences en édition d’image.</li>
    <li>Toute personne désirant acquérir une compétence certifiée dans le domaine de l’édition d’image.</li>
  </ul><br/>
  
  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Assimiler les concepts essentiels et les techniques à maîtriser pour comprendre les principales notions liées aux images numériques.</li>
    <li>Utiliser une application de traitement d’images dans le but d’améliorer les images, de leur appliquer des effets et de les préparer pour l’impression et la publication.</li>
  </ul><br/>
  
  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>
  
  <h3>Objectif final :</h3>
  <ul>
    <li>Connaître les principaux concepts liés à l'utilisation des images numériques, comprendre les options des formats graphiques et les notions liées aux couleurs.</li>
    <li>Ouvrir une image existante, enregistrer une image dans différents formats et définir les options du fichier de sauvegarde.</li>
    <li>Utiliser efficacement les options intégrées comme l'affichage des barres d'outils et des palettes pour améliorer la productivité et réaliser la création et le traitement d'une image.</li>
    <li>Capturer et enregistrer une image, utiliser des outils variés de sélection et manipuler les images, créer et utiliser des calques, travailler avec du texte, utiliser des effets et des filtres, utiliser des outils de dessin et peinture pour réaliser des modifications sur une image.</li>
    <li>Utiliser les outils de dessin et de peinture du logiciel pour modifier une image.</li>
    <li>Préparer les images pour l'impression ou la publication.</li>
  </ul>
</div>
`, module: `
<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p><br/>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Introduction aux images numériques et formats graphiques</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Définition des images bitmap et vectorielles.</li>
      <li>Les formats d’image (JPEG, PNG, TIFF, PSD, etc.) et leurs spécificités.</li>
      <li>Notions de résolution, DPI et colorimétrie (RVB, CMJN, niveaux de gris).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Prise en main de l’interface Photoshop</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation des menus, barres d’outils et palettes.</li>
      <li>Personnalisation de l’espace de travail.</li>
      <li>Navigation dans une image : zoom, règles, grilles et repères.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Gestion des fichiers et options d’enregistrement</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Ouvrir et importer une image existante.</li>
      <li>Enregistrer et exporter dans différents formats.</li>
      <li>Options de compression et qualité d’image.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Sélections et manipulation des images</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation des outils de sélection (rectangle, lasso, baguette magique, sélection rapide).</li>
      <li>Recadrage, redimensionnement et rotation des images.</li>
      <li>Techniques d’isolation et d’extraction d’éléments.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Travail avec les calques et le texte</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Création, gestion et fusion des calques.</li>
      <li>Modes de fusion et options d’opacité.</li>
      <li>Ajout et mise en forme de texte (polices, styles, effets).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Application d’effets et utilisation des filtres</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Ombres, lueurs et styles de calques.</li>
      <li>Filtres de flou, netteté et distorsion.</li>
      <li>Effets artistiques et de transformation.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 7 : Outils de dessin et de peinture</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation du pinceau et des outils de remplissage.</li>
      <li>Création et personnalisation des motifs et dégradés.</li>
      <li>Outils de correction (tampon, correcteur, pièce, densité, etc.).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 8 : Préparation des images pour impression et publication</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Réglage des couleurs et conversion des modes colorimétriques.</li>
      <li>Recadrage et redimensionnement en fonction du support final.</li>
      <li>Enregistrement optimisé pour le web et l’impression.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du test ICDL et des compétences évaluées.</li>
      <li>Exercices pratiques pour valider les acquis.</li>
      <li>Passage d’un test blanc pour se préparer à l’examen.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale composée d’un test théorique en ligne et d’un projet pratique intégrateur.</li>
      <li>Attribution d’une certification attestant de la maîtrise des techniques d’édition d’image.</li>
    </ul>
  </div>
</div>
`
  },
  {
    id: 5,
    image: "logo-word.png",
    bannerImg: "course-banner3.jpg",
    name: "Bureautique",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    price: "1 000 €",
    duration: "13H",
    language: "Langue française",
    type: "Digitale",
    title: "Formation Word",
    about: `
<div class="tab-pane">
  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Maîtriser les fonctionnalités principales des logiciels d’élaboration d’un document texte.</li>
    <li>Apprendre les opérations quotidiennes et la mise en forme de documents structurés.</li>
    <li>Préparer des documents pour l’impression de manière optimale.</li>
  </ul><br/>
  
  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>
  
  <h3>Objectif final :</h3>
  <ul>
    <li>Reconnaître l'interface d'un logiciel de traitement de texte et ses principales fonctionnalités.</li>
    <li>Réaliser les opérations de base pour insérer et éditer des données dans un document.</li>
    <li>Utiliser les options de formatage et de style pour structurer un document de manière professionnelle.</li>
    <li>Créer et insérer des objets (images, tableaux, graphiques) pour enrichir le contenu.</li>
    <li>Maîtriser la mise au point et la gestion de données pour une utilisation efficace du publipostage.</li>
    <li>Définir la mise en forme et utiliser les fonctionnalités de vérification pour assurer une impression optimale.</li>
  </ul>
</div>
`
  , module: `
<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p><br/>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Prise en main de l'interface Word</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Découverte de l'interface utilisateur : ruban, onglets, groupes de commandes.</li>
      <li>Présentation des principales fonctionnalités : barre d'outils, réglages et affichage du document.</li>
      <li>Utilisation des raccourcis clavier pour une navigation efficace.</li>
      <li>Gestion des fichiers : ouverture, sauvegarde et formats compatibles.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Opérations de base et édition de texte</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Saisie et modification de texte : correction et suppression.</li>
      <li>Sélection de contenu : texte, paragraphes, tableaux et images.</li>
      <li>Copier, couper, coller et déplacement de contenus.</li>
      <li>Utilisation des options de recherche et de remplacement.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Mise en forme et utilisation des styles</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Application des options de mise en forme (police, taille, couleur, alignement).</li>
      <li>Utilisation des styles prédéfinis et création de styles personnalisés.</li>
      <li>Gestion des paragraphes : interlignage, retraits, puces et numérotation.</li>
      <li>Mise en page avancée : colonnes, marges et orientation du document.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Insertion d'objets et enrichissement du document</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Insertion et modification d'images et formes graphiques.</li>
      <li>Ajout de tableaux et gestion des données tabulaires.</li>
      <li>Utilisation des SmartArt et graphiques.</li>
      <li>Gestion des liens hypertextes et des annotations.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Publipostage et automatisation des documents</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Création d'une liste de destinataires et gestion des sources de données.</li>
      <li>Fusion de documents pour la création de courriers personnalisés.</li>
      <li>Utilisation des champs de fusion et paramétrage du publipostage.</li>
      <li>Impression et enregistrement des documents fusionnés.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Mise en page et impression</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Paramétrage de la mise en page : marges, en-têtes et pieds de page.</li>
      <li>Vérification et correction orthographique et grammaticale.</li>
      <li>Utilisation des commentaires et suivi des modifications.</li>
      <li>Aperçu avant impression et configuration de l'impression.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Explication du déroulement de l'examen de certification ICDL.</li>
      <li>Exercice de mise en pratique sur les compétences abordées.</li>
      <li>Test blanc pour préparer les stagiaires aux exigences de la certification.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale composée d’un test théorique en ligne et d’un projet pratique intégrateur.</li>
      <li>Attribution de la certification ICDL en Traitement de Texte pour les apprenants ayant satisfait aux critères d’évaluation.</li>
    </ul>
  </div>
</div>
`
  },
  {
    id: 6,
    image: "excel-seeklogo.png",
    bannerImg: "course-banner3.jpg",
    name: "Bureautique",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    price: "1 200 €",
    duration: "15H",
    language: "Langue française",
    type: "Digitale",
    title: "Formation Excel",
    about: `
<div class="tab-pane">
  <h3>Cette formation est pour qui ?</h3>
  <ul>
    <li>Professionnels souhaitant améliorer leurs compétences en gestion de données.</li>
    <li>Analystes, comptables, responsables administratifs et toute personne désireuse d’exploiter un tableur de manière performante.</li>
    <li>Toute personne souhaitant acquérir une compétence certifiée dans le domaine du tableur.</li>
  </ul><br/>

  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Maîtriser les fonctionnalités principales des logiciels tableurs.</li>
    <li>Effectuer les opérations courantes : création de tableaux, utilisation de formules et mise en forme.</li>
    <li>Créer et exploiter des graphiques pour visualiser les données.</li>
  </ul><br/>

  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>

  <h3>Objectif final :</h3>
  <ul>
    <li>Reconnaître l'interface d'un logiciel de tableur et ses principales fonctionnalités.</li>
    <li>Utiliser les cellules d'une feuille de calcul pour éditer, trier et organiser des données.</li>
    <li>Travailler efficacement avec des feuilles de calcul.</li>
    <li>Utiliser des formules et des fonctions simples pour réaliser des opérations de calcul.</li>
    <li>Mettre en forme les données pour optimiser leur présentation.</li>
    <li>Créer et éditer un graphique à l'aide des informations figurant dans la feuille de calcul.</li>
    <li>Définir la mise en forme d'un document et maîtriser les fonctionnalités de vérification pour assurer une impression optimale.</li>
  </ul>
</div>
`
  , module: `
<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p><br/>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Découverte d’Excel et de son interface</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du ruban, des onglets et des groupes de commandes.</li>
      <li>Gestion des fichiers (création, ouverture, enregistrement).</li>
      <li>Navigation entre feuilles et classeurs.</li>
      <li>Paramétrages de base (zoom, affichage, raccourcis).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Manipulation et organisation des données</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Saisie et modification des données dans les cellules.</li>
      <li>Sélection et déplacement de cellules et de plages de données.</li>
      <li>Tri et filtrage des informations.</li>
      <li>Utilisation des validations de données.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Travailler efficacement avec des feuilles de calcul</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Insertion et suppression de lignes/colonnes.</li>
      <li>Gestion des feuilles (ajout, suppression, renommage, déplacement).</li>
      <li>Protection et verrouillage des cellules et feuilles.</li>
      <li>Liaisons entre plusieurs feuilles.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Formules et fonctions de calcul</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation des formules de base (addition, soustraction, multiplication, division).</li>
      <li>Fonctions courantes : SOMME, MOYENNE, MIN, MAX.</li>
      <li>Fonctions conditionnelles (SI, SOMME.SI, NB.SI).</li>
      <li>Fonctions de recherche et de référence (RECHERCHEV, INDEX, EQUIV).</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Mise en forme des données</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Formats des cellules (nombre, texte, date, pourcentage).</li>
      <li>Mise en forme conditionnelle.</li>
      <li>Alignement, fusion et fractionnement des cellules.</li>
      <li>Gestion des styles et des thèmes.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Création et personnalisation des graphiques</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Sélection des données pour un graphique.</li>
      <li>Choix du type de graphique (histogrammes, courbes, secteurs, etc.).</li>
      <li>Personnalisation des titres, axes et légendes.</li>
      <li>Mise en forme avancée des graphiques.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 7 : Mise en page et impression</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Définition des marges, orientation et en-têtes/pieds de page.</li>
      <li>Aperçu avant impression et options avancées d’impression.</li>
      <li>Vérification et correction orthographique.</li>
      <li>Protection des documents et suivi des modifications.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du test ICDL et des compétences évaluées.</li>
      <li>Exercices pratiques de validation des acquis.</li>
      <li>Passage d’un test blanc pour se préparer à l’examen.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale composée d’un test théorique en ligne et d’un projet pratique intégrateur.</li>
      <li>Attribution d’une certification attestant de la maîtrise des outils de tableur.</li>
    </ul>
  </div>
</div>
`
  },
  {
    id: 7,
    image: "workspace.webp",
    bannerImg: "course-banner3.jpg",
    name: "Bureautique",
    author: "CO2 FORMATION",
    authorImg: "author.png",
    price: "2 000 €",
    duration: "25H",
    language: "Langue française",
    type: "Digitale",
    title: "Formation Google Workspace",
    about: `
<div class="tab-pane">
  <h3>Cette formation est pour qui ?</h3>
  <ul>
    <li>Professionnels, managers, collaborateurs et télétravailleurs souhaitant optimiser leur collaboration numérique.</li>
    <li>Responsables de projets et toute personne désireuse de mettre en place un environnement de travail collaboratif efficace.</li>
  </ul><br/>

  <h3>Objectif de la formation :</h3>
  <ul>
    <li>Maîtriser les concepts et compétences essentiels nécessaires pour travailler efficacement en équipe à l’aide d’outils collaboratifs.</li>
    <li>Comprendre les concepts clés de la collaboration numérique.</li>
    <li>Gérer le calendrier et organiser efficacement les tâches.</li>
    <li>Utiliser des outils de communication et de gestion documentaire.</li>
    <li>Stocker et partager des données de manière sécurisée.</li>
  </ul><br/>

  <h3>Moyen pédagogique :</h3>
  <ul>
    <li>Supports multimédias (vidéos, tutoriels, fiches synthèses).</li>
    <li>Plateforme de e-learning accessible 24/7.</li>
    <li>Séances interactives en visio (via Zoom, Teams, etc.).</li>
    <li>Exercices pratiques, études de cas et forums de discussion.</li>
  </ul><br/>

  <h3>Objectif final :</h3>
  <ul>
    <li>Appréhender les notions relatives à l'utilisation de plateformes et aux outils collaboratifs.</li>
    <li>Gérer les calendriers et les tâches pour améliorer la coordination et l'efficacité de l'équipe.</li>
    <li>Utiliser des outils collaboratifs appropriés pour communiquer par le biais de conversations, de réunions et de webinaires.</li>
    <li>Utiliser des outils collaboratifs appropriés pour stocker et partager des informations, générer des idées et des résultats.</li>
  </ul>
</div>
`,
    module: `
<div class="tab-pane">
  <h3>Modalité d’accès :</h3>
  <p>Un entretien pour évaluer les besoins spécifiques des participants. La formation est accessible aux personnes en situation de handicap. Des aménagements spécifiques peuvent être proposés en fonction des besoins individuels, en coordination avec notre référent handicap.</p><br/>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 1 : Introduction aux plateformes collaboratives et à Google Workspace</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation de Google Workspace et ses principales applications.</li>
      <li>Comparaison avec d'autres outils collaboratifs (Microsoft 365, Zoho, etc.).</li>
      <li>Configuration d’un compte Google et personnalisation des paramètres.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 2 : Gestion des calendriers et des tâches</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation de Google Agenda pour organiser des réunions et événements.</li>
      <li>Création et gestion des tâches et rappels avec Google Tasks et Google Keep.</li>
      <li>Partage et synchronisation des calendriers pour améliorer la collaboration.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 3 : Communication et organisation des réunions en ligne</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation de Google Chat pour les conversations d’équipe.</li>
      <li>Organisation de visioconférences et webinaires avec Google Meet.</li>
      <li>Paramétrage des salles de réunion, partage d’écran et enregistrement des sessions.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 4 : Stockage et partage d’informations avec Google Drive</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Organisation des fichiers et dossiers dans Google Drive.</li>
      <li>Paramètres de partage et collaboration en temps réel sur les documents.</li>
      <li>Gestion des droits d'accès et suivi des modifications.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 5 : Création et collaboration sur des documents Google</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Utilisation de Google Docs pour la rédaction collaborative.</li>
      <li>Google Sheets : création et modification de feuilles de calcul à plusieurs.</li>
      <li>Google Slides : conception et partage de présentations en équipe.</li>
      <li>Historique des versions et récupération des fichiers.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Module 6 : Outils avancés et intégration avec d'autres applications</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Google Forms : création de sondages et formulaires en ligne.</li>
      <li>Google Jamboard : génération et structuration des idées en équipe.</li>
      <li>Intégration des outils Google Workspace pour une collaboration fluide.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Préparation à l’examen :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Présentation du test ICDL et des compétences évaluées.</li>
      <li>Exercices pratiques pour valider les acquis.</li>
      <li>Passage d’un test blanc pour se préparer à l’examen.</li>
    </ul>
  </div>

  <div class="single-week">
    <ul class="week__top">
      <li>Certification :</li>
    </ul>
    <h3>Contenu :</h3>
    <ul class="course__title">
      <li>Évaluation finale combinant un test théorique en ligne et un projet pratique intégrateur.</li>
      <li>Attribution d’une certification attestant de la maîtrise des outils collaboratifs.</li>
    </ul>
  </div>
</div>
`
  },
]


export default courses